import { render, staticRenderFns } from "./CellRendererCarrier.vue?vue&type=template&id=050b3913"
import script from "./CellRendererCarrier.vue?vue&type=script&lang=js"
export * from "./CellRendererCarrier.vue?vue&type=script&lang=js"
import style0 from "./CellRendererCarrier.vue?vue&type=style&index=0&id=050b3913&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports